import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {ExtendedFormBuilder} from '@aviary/forms/extensions/extended-form-builder/extended-form-builder';
import {FormDialog, FormDialogDefinition} from '@aviary/dialogs/form-dialog/form-dialog.types';
import {FormDialogComponent} from '@aviary/dialogs/form-dialog/form-dialog.component';
import {CardLoginValue, EmailLoginValue} from '@store/patron/patron.types';
import {LoginComponent} from '@app/index/login/login.component';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {MEDIUM_DIALOG_CONFIG} from '@aviary/dialogs/base-dialog/base-dialog.types';

@Component({
  selector: 'px-login-dialog',
  template: `
    <mx-form-dialog [definition]="dialogDefinition" [showCancelButton]="false" [showConfirmButton]="false">
      <px-login (loginSubmit)="onLoginSubmit($event)"/>
    </mx-form-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormDialogComponent, LoginComponent]
})
export class LoginDialog implements FormDialog<undefined, EmailLoginValue | CardLoginValue> {
  public static readonly dialogConfigOverrides: MatDialogConfig = {...MEDIUM_DIALOG_CONFIG, disableClose: false};
  public readonly dialogData = undefined;
  // this component is a wrapper for the login component's forms and passes along the submit value
  // this form group is a placeholder to satisfy FormDialog
  private readonly blankForm: ExtendedFormGroup = inject(ExtendedFormBuilder).nonNullable.extendedGroup({});
  private readonly dialog: MatDialogRef<LoginDialog> = inject(MatDialogRef);

  onLoginSubmit(value: EmailLoginValue | CardLoginValue) {
    this.dialog.close(value);
  }

  public readonly dialogDefinition: FormDialogDefinition<EmailLoginValue | CardLoginValue> = {
    title: 'Login',
    formGroup: this.blankForm
  };
}
